import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as Icon from '../../components/icons';
import FeedLayoutTooltip from './FeedLayoutTooltip';

interface EnhancedFeedLayoutTooltipProps {
  maxVisibleItems?: number;
  allowModeToggle?: boolean; // Whether to show mode selection controls
}

type TooltipMode = 'current' | 'all-grouped' | 'all-combined';

const EnhancedFeedLayoutTooltip: React.FC<EnhancedFeedLayoutTooltipProps> = ({
  maxVisibleItems = 5,
  allowModeToggle = true,
}) => {
  const { t } = useTranslation('feed');
  const [tooltipMode, setTooltipMode] = useState<TooltipMode>('all-grouped');

  const tooltipModes = {
    current: {
      key: 'current',
      title: t`Current Metric`,
      description: t`Show only current metric type`,
      showAllMetrics: false,
      groupByDataType: false,
      icon: Icon.CircleInfo,
    },
    'all-grouped': {
      key: 'all-grouped',
      title: t`All Metrics (Grouped)`,
      description: t`Show events and assignments separately`,
      showAllMetrics: true,
      groupByDataType: true,
      icon: Icon.CircleInfo,
    },
    'all-combined': {
      key: 'all-combined',
      title: t`All Metrics (Combined)`,
      description: t`Show all metrics together`,
      showAllMetrics: true,
      groupByDataType: false,
      icon: Icon.CircleInfo,
    },
  };

  const currentModeConfig = tooltipModes[tooltipMode];

  return (
    <>
      {/* Mode Selection Controls (Optional) */}
      {/* {allowModeToggle && (
        <div
          className={classNames(
            'absolute bottom-4 left-4 z-50',
            'bg-app-panel-dark/90 backdrop-blur-lg',
            'border-menu-600/30 rounded-lg border',
            'p-2',
          )}
        >
          <DropdownSelector
            classNameLabel="text-xs"
            buttonTransparent
            value={tooltipMode}
            values={Object.keys(tooltipModes)}
            renderValue={key => {
              const mode = tooltipModes[key];
              const IconComponent = mode.icon;
              return (
                <div className="flex items-center gap-2">
                  <IconComponent className="h-3 w-3" />
                  <span>{mode.title}</span>
                </div>
              );
            }}
            onChange={key => setTooltipMode(key as TooltipMode)}
          />
        </div>
      )} */}

      {/* Enhanced Tooltip */}
      <FeedLayoutTooltip
        maxVisibleItems={maxVisibleItems}
        showAllMetrics={currentModeConfig.showAllMetrics}
        groupByDataType={currentModeConfig.groupByDataType}
      />
    </>
  );
};

export default EnhancedFeedLayoutTooltip;
